import React from 'react'

import { useAmplitude } from '@Analytics/hook'
import { HtmlBlock as HTMLBlockGraphQL } from '@Generated/graphql'
import { pageTypeToDestinationPageType } from '@Globals/Page/Mappers'

import styles from './HTMLBlock.module.scss'

const HTMLBlock = ({
  data,
  id,
}: {
  data: HTMLBlockGraphQL
  id?: string
}) => {
  const ampli = useAmplitude()

  if (!data.html) {
    return null
  }

  return (
    <div
      className={styles.block}
      dangerouslySetInnerHTML={{ __html: data.html }}
      id={id}
      onClick={(e: any) => {
        if (!e.target) {
          return
        }

        const pageType = pageTypeToDestinationPageType(e.target.getAttribute?.('data-analytics-page-type') || '')
        const pageID = e.target.getAttribute?.('data-analytics-page-id') || ''
        const sourceID = e.target.getAttribute?.('data-analytics-source-id') || undefined

        if (!pageType || !pageID) {
          return
        }

        ampli.navLinkClick({
          dest_page_type_id: pageID,
          dest_page_type: pageType,
          source_id: sourceID,
        })
      }}
    />
  )
}

export default HTMLBlock
